<div class="row">
  <div class="col s12 l9">
    <div class="row">
      <div class="col s12 m12">
        <p>
          This privacy policy has been compiled to better serve those who are concerned with how their &lsquo;Personally
          Identifiable Information&rsquo; (PII) is being used online. PII, as described in US privacy law and
          information security, is information that can be used on its own or with other information to identify,
          contact, or locate a single person, or to identify an individual in context. Please read our privacy policy
          carefully to get a clear understanding of how we collect, use, protect or otherwise handle your Personally
          Identifiable Information in accordance with our website.
        </p>
        <p>
          <br />
          <strong>What personal information do we collect from the people that visit our blog, website or app?</strong
          ><br />
          When ordering or registering on our site, as appropriate, you might be asked to enter your name, email
          address, phone number or other details to help you with your experience.
        </p>
        <p>
          <br />
          <strong>When do we collect information?</strong><br />
          We collect information from you when you register on our site or enter information on our site.
        </p>
        <p>
          <br />
          <strong>How do we use your information?</strong><br />
          We might use the information we collect from you when you register, make a purchase, sign up for our
          newsletter, respond to a survey or marketing communication, surf the website, or use certain other site
          features in the following ways:<br />
          &bull; To quickly process your transactions.<br />
          &bull; To send periodic emails regarding your order or other products and services.
        </p>
        <p>
          <br />
          <strong>How do we protect your information?</strong><br />
          Our website is scanned on a regular basis for security holes and known vulnerabilities in order to make your
          visit to our site as safe as possible.
        </p>
        <p>
          <br />
          We use regular Malware Scanning.
        </p>
        <p>
          <br />
          Your personal information is contained behind secured networks and is only accessible by a limited number of
          persons who have special access rights to such systems, and are required to keep the information confidential.
          In addition, all sensitive/credit information you supply is encrypted via Secure Socket Layer (SSL)
          technology.<br />
          We implement a variety of security measures when a user places an order enters, submits, or accesses their
          information to maintain the safety of your personal information.<br />
          All transactions are processed through a gateway provider and are not stored or processed on our servers.
        </p>
        <p>
          <br />
          <strong>Do we use &lsquo;cookies&rsquo;?</strong><br />
          Yes. Cookies are small files that a site or its service provider transfers to your computer&rsquo;s hard drive
          through your Web browser (if you allow) that enables the site&rsquo;s or service provider&rsquo;s systems to
          recognize your browser and capture and remember certain information. For instance, we use cookies to help us
          remember and process the items in your shopping cart. They are also used to help us understand your
          preferences based on previous or current site activity, which enables us to provide you with improved
          services. We also use cookies to help us compile aggregate data about site traffic and site interaction so
          that we can offer better site experiences and tools in the future.<br />
          We use cookies to:<br />
          &bull; Understand and save user&rsquo;s preferences for future visits.
        </p>
        <p>
          <br />
          You can choose to have your computer warn you each time a cookie is being sent, or you can choose to turn off
          all cookies. You do this through your browser settings. Since browser is a little different, look at your
          browser&rsquo;s Help Menu to learn the correct way to modify your cookies.
        </p>
        <p>
          <br />
          If you turn cookies off, Some of the features that make your site experience more efficient might not function
          properly.It won&rsquo;t affect the user&rsquo;s experience that make your site experience more efficient and
          might not function properly.
        </p>
        <p>
          <br />
          <strong>Third-party disclosure</strong><br />
          We do not sell, trade, or otherwise transfer to outside parties your Personally Identifiable Information.
        </p>
        <p>
          <br />
          <strong>Third-party links</strong><br />
          We do not include or offer third-party products or services on our website.
        </p>
        <p>
          <br />
          <strong>Google</strong><br />
          Google&rsquo;s advertising requirements can be summed up by Google&rsquo;s Advertising Principles. They are
          put in place to provide a positive experience for users.
          https://support.google.com/adwordspolicy/answer/1316548?hl=en<br />
          We use Google AdSense Advertising on our website.<br />
          Google, as a third-party vendor, uses cookies to serve ads on our site. Google&rsquo;s use of the DART cookie
          enables it to serve ads to our users based on previous visits to our site and other sites on the Internet.
          Users can opt-out of the use of the DART cookie by visiting the Google Ad and Content Network privacy
          policy.<br />
          We have implemented the following:<br />
          &bull; Remarketing with Google AdSense
        </p>
        <p>
          <br />
          We, along with third-party vendors such as Google use first-party cookies (such as the Google Analytics
          cookies) and third-party cookies (such as the DoubleClick cookie) or other third-party identifiers together to
          compile data regarding user interactions with ad impressions and other ad service functions as they relate to
          our website.
        </p>
        <p>
          <br />
          Opting out:<br />
          Users can set preferences for how Google advertises to you using the Google Ad Settings page. Alternatively,
          you can opt out by visiting the Network Advertising Initiative Opt Out page or by using the Google Analytics
          Opt Out Browser add on.
        </p>
        <p>
          <br />
          <strong>California Online Privacy Protection Act</strong><br />
          CalOPPA is the first state law in the nation to require commercial websites and online services to post a
          privacy policy. The law&rsquo;s reach stretches well beyond California to require any person or company in the
          United States (and conceivably the world) that operates websites collecting Personally Identifiable
          Information from California consumers to post a conspicuous privacy policy on its website stating exactly the
          information being collected and those individuals or companies with whom it is being shared. - See more at:
          https://consumercal.org/california-online-privacy-protection-act-caloppa/#sthash.0FdRbT51.dpuf<br />
          According to CalOPPA, we agree to the following:<br />
          * Users can visit our site anonymously.<br />
          * Once this privacy policy is created, we will add a link to it on our home page or as a minimum, on the first
          significant page after entering our website.<br />
          * Our Privacy Policy link includes the word &lsquo;Privacy&rsquo; and can easily be found on the page
          specified above.<br />
          * You will be notified of any Privacy Policy changes on our Privacy Policy Page<br />
          * Can change your personal information by logging in to your account
        </p>
        <p>
          <br />
          <strong>How does our site handle Do Not Track signals?</strong><br />
          We honor Do Not Track signals and Do Not Track, plant cookies, or use advertising when a Do Not Track (DNT)
          browser mechanism is in place.
        </p>
        <p>
          <br />
          <strong>Does our site allow third-party behavioral tracking?</strong><br />
          It&rsquo;s also important to note that we do not allow third-party behavioral tracking<br />
          COPPA (Children Online Privacy Protection Act)<br />
          When it comes to the collection of personal information from children under the age of 13 years old, the
          Children&rsquo;s Online Privacy Protection Act (COPPA) puts parents in control. The Federal Trade Commission,
          United States&rsquo; consumer protection agency, enforces the COPPA Rule, which spells out what operators of
          websites and online services must do to protect children&rsquo;s privacy and safety online.<br />
          We do not specifically market to children under the age of 13 years old.<br />
          <br />
          <strong>Fair Information Practices</strong><br />
          The Fair Information Practices Principles form the backbone of privacy law in the United States and the
          concepts they include have played a significant role in the development of data protection laws around the
          globe. Understanding the Fair Information Practice Principles and how they should be implemented is critical
          to comply with the various privacy laws that protect personal information.<br />
          In order to be in line with Fair Information Practices we will take the following responsive action, should a
          data breach occur:<br />
          We will notify you via email<br />
          &bull; Within 7 business days
        </p>
        <p>
          <br />
          We also agree to the Individual Redress Principle which requires that individuals have the right to legally
          pursue enforceable rights against data collectors and processors who fail to adhere to the law. This principle
          requires not only that individuals have enforceable rights against data users, but also that individuals have
          recourse to courts or government agencies to investigate and/or prosecute non-compliance by data processors.
        </p>
        <p>
          <br />
          <strong>CAN SPAM Act</strong><br />
          The CAN-SPAM Act is a law that sets the rules for commercial email, establishes requirements for commercial
          messages, gives recipients the right to have emails stopped from being sent to them, and spells out tough
          penalties for violations.<br />
          We collect your email address in order to:<br />
          &bull; Send information, respond to inquiries, and/or other requests or questions<br />
          To be in accordance with CANSPAM, we agree to the following:<br />
          &bull; Not use false or misleading subjects or email addresses.<br />
          &bull; Identify the message as an advertisement in some reasonable way.<br />
          &bull; Include the physical address of our business or site headquarters.<br />
          &bull; Monitor third-party email marketing services for compliance, if one is used.<br />
          &bull; Honor opt-out/unsubscribe requests quickly.<br />
          &bull; Allow users to unsubscribe by using the link at the bottom of each email.<br />
          If at any time you would like to unsubscribe from receiving future emails, you can email us at<br />
          &bull; Follow the instructions at the bottom of each email.<br />
          and we will promptly remove you from ALL correspondence.
        </p>
        <p>
          <br />
          <strong>Contacting Us</strong><br />
          If there are any questions regarding this privacy policy, you can contact us using the information below.<br />
          smartresponse.org<br />
          4402 Bestor Drive<br />
          Rockville, Maryland 20853<br />
          USA<br />
          info@smartresponse.org<br />
          Last Edited on 2017-08-29
        </p>
      </div>
    </div>
  </div>
</div>
